import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import * as moment from "moment";
import { take } from "rxjs/operators";
import { exportExcel } from "src/app/helpers/helpers";

@Component({
  selector: "app-root-customers",
  templateUrl: "./root-customers.component.html",
  styleUrls: ["./root-customers.component.scss"],
})
export class RootCustomersComponent implements OnInit {
  message = "";
  selectedCustomer;

  customers = [];

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.http
      .get("/getCustomers")
      .pipe(take(1))
      .subscribe((res: any) => {
        this.customers = res.map((m) => ({
          ...m,
          reports: m.reports.map((r) => ({
            ...r,
            createdOn: new Date(r.createdOn),
          })),
        }));
        for (const customer of this.customers) {
          customer.reports.sort(
            (a, b) => b.createdOn.getTime() - a.createdOn.getTime()
          );
          if (customer.reports.length > 0) {
            customer.report = {
              ...customer.reports[0],
              createdOnString: moment(customer.reports[0].createdOn).format(
                "DD-MM-yyyy HH:mm"
              ),
              anotherReportString:
                customer.reports.length > 1 ? "Evet" : "Hayır",
            };

            let finishTimeInSecondsString = "";
            if (customer.report.finishTimeInSeconds) {
              const minutes = Math.floor(
                customer.report.finishTimeInSeconds / 60
              );
              const remainingSeconds = customer.report.finishTimeInSeconds % 60;
              finishTimeInSecondsString = `${minutes} dk. ${remainingSeconds} sn.`;
            }
            customer.report.finishTimeInSecondsString =
              finishTimeInSecondsString;
          }
        }
      });
  }

  newCustomer() {
    this.selectedCustomer = {
      id: "",
      name: "",
      email: "",
      password: "",
      age: "",
      gender: null,
      isAdmin: false,
      isRoot: false,
      isActive: true,
    };
  }

  selectCustomer(data) {
    this.selectedCustomer = {
      ...data,
      reports: null,
      report: null,
    };
    delete this.selectedCustomer.reports;
    delete this.selectedCustomer.report;
  }

  saveChanges() {
    this.http
      .post("/fastSaveCustomer", {
        ...this.selectedCustomer,
      })
      .pipe(take(1))
      .subscribe((res: any) => {
        alert(res.data);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      });
  }

  removeCustomer() {
    let isConfirmed = confirm(
      "Bu kullaniciyi silmek istediginize emin misinz?"
    );
    if (isConfirmed) {
      this.http
        .post("/fastRemoveCustomer", {
          id: this.selectedCustomer._id,
        })
        .pipe(take(1))
        .subscribe((res: any) => {
          alert(res.data);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        });
    }
  }

  downloadUserReports() {
    const output = [];
    for (const customer of this.customers) {
      if (customer.reports.length === 0) {
        customer.reports.push({});
      }

      for (let i = 0; i < customer.reports.length; i++) {
        const report = customer.reports[i];
        output.push({
          ["Telefon"]: customer.phone,
          ["Adı Soyadı"]: customer.name,
          ["Durumu"]:
            customer.isActive == "false" || !customer.isActive
              ? "Pasif"
              : "Aktif",
          ["Ticari İleti"]: this.ticariIletiText(customer),
          ["Açık Rıza Onayı"]: customer.openConsentAgreement ? "Var" : "Yok",
          ["Ret"]: this.retText(customer),
          ["Cinsiyet"]: report.gender || customer.reports[0].gender,
          ["Yaş"]: report.age || customer.reports[0].age,
          ["Eğitim Durumu"]:
            report.educationStatus || customer.reports[0].educationStatus,
          ["Şehir"]: report.city || customer.reports[0].city,
          ["Katıldığı Araştırmalar"]:
            report.companyName || customer.reports[0].companyName,
          ["Katılma Tarihi"]:
            report.createdOn || customer.reports[0].createdOn
              ? new Date(report.createdOn || customer.reports[0].createdOn)
              : "",
        });
      }
    }
    exportExcel(output, "musteriler");
  }

  ticariIletiText(customer) {
    const texts = [
      customer.ticariIletiAgreement ? "Sms Var" : "Sms Yok",
      customer.ticariIletiAgreementEmail ? "Email Var" : "Email Yok",
      customer.ticariIletiAgreementIvr ? "IVR Var" : "IVR Yok",
    ];
    return texts.join(" - ");
  }

  retText(customer) {
    const texts = [
      customer.ticariIletiAgreementRejectionDate
        ? `Sms Ret (Tarih: ${moment(
            customer.ticariIletiAgreementRejectionDate
          ).format("DD-MM-yyyy HH:mm")})`
        : "Sms Ret Yok",
      customer.ticariIletiAgreementEmailRejectionDate
        ? `Email Ret (Tarih: ${moment(
            customer.ticariIletiAgreementEmailRejectionDate
          ).format("DD-MM-yyyy HH:mm")})`
        : "Email Ret Yok",
      customer.ticariIletiAgreementIvrRejectionDate
        ? `IVR Ret (Tarih: ${moment(
            customer.ticariIletiAgreementIvrRejectionDate
          ).format("DD-MM-yyyy HH:mm")})`
        : "IVR Ret Yok",
    ];
    return texts.join(" - ");
  }
}
